import { ButtonERP } from "@finanedi.es/storybook"
import PagosDeleteImg from "assets/eliminar_pago.svg"
import RemesasDeleteImg from "assets/eliminar_remesa.svg"
import Spinner from "common/components/Spinner/Spinner"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import Modal from "../Modal"
import { IconDeletetypes } from "./constants"

const DeleteModal = ({
  visible,
  onHide,
  footer = "",
  resizable = false,
  draggable = false,
  position = "center",
  closable = true,
  iconType = "",
  onConfirm,
  buttonLabel = "",
  title = "",
  message = "",
  ...props
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const onRenderIcon = useMemo(() => {
    const ICON_GROUP = {
      [IconDeletetypes.remesas]: (
        <img
          src={RemesasDeleteImg}
          alt='eliminar_remesa'
        />
      ),
      [IconDeletetypes.pagos]: (
        <img
          src={PagosDeleteImg}
          alt='eliminar_pago'
        />
      ),
    }

    return iconType ? ICON_GROUP[iconType] : <Spinner />
  }, [iconType])

  return (
    <Modal
      visible={visible}
      footer={footer}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onHide={typeof onHide === "function" ? onHide : () => {}}
      draggable={draggable}
      baseZIndex={9999}
      resizable={resizable}
      position={position}
      closable={closable}
      closeOnEscape={false}
      size='small'
      {...props}
    >
      <div className='tw-mb-2 tw-flex tw-flex-col tw-text-center tw-w-full'>
        <div className='tw-mb-2 tw-mx-auto'>{onRenderIcon}</div>
        <div>
          <h4 className='tw-text-primary tw-text-2xl tw-font-bold'>{title}</h4>
          <p className='mt-3 tw-text-base'>{message}</p>
          <div className='tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-4'>
            <ButtonERP
              customize={{
                type: "white",
                size: "md",
              }}
              onClick={onHide}
              label={`${t("bancos.table.modal.cancelButton")}`}
            />
            <ButtonERP
              customize={{
                type: "danger",
                size: "md",
              }}
              label={buttonLabel}
              onClick={onConfirm}
              loading={props.isLoading}
              disabled={props.isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteModal
